import React, { useContext } from 'react';
import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    IconButton,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { ContextUserProfile } from '../../../../../../contexts/UserProfileContext';
import AriTable from './AriTable';

const CalendarPopUp = props => {
    const { isOpen, handleClose, selectedEvents, selectedDate } = props;
    const { translate } = useContext(ContextUserProfile);

    const capitalizeFirstLetter = str =>
        `${str[0].toUpperCase()}${str.slice(1)}`;
    const txtDate = capitalizeFirstLetter(translate('date'));
    return (
        <Dialog
            open={isOpen}
            onClose={handleClose}
            aria-labelledby='draggable-dialog-title'
            maxWidth='xl'
            className='container__popup--custom__dialog'
        >
            <DialogTitle style={{ cursor: 'move' }} id='draggable-dialog-title'>
                {txtDate}: {selectedDate}
                <IconButton
                    aria-label='close'
                    onClick={handleClose}
                    sx={{
                        position: 'absolute',
                        right: 14,
                        top: 14,
                        color: theme => theme.palette.grey[500],
                    }}
                >
                    <CloseIcon />
                </IconButton>
            </DialogTitle>
            <DialogContent className='dialog__content'>
                <AriTable items={selectedEvents} />
            </DialogContent>
            <DialogActions
                classes={{
                    root: 'dialog__footer dialog__footer--right',
                }}
            >
                <Button
                    size='small'
                    variant='contained'
                    className='accept__button'
                    onClick={handleClose}
                >
                    {translate('close')}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default CalendarPopUp;
